import z from 'zod/v3';
import {
  ValidationDashboardDataObjectVersionSchema,
  ValidationDashboardSchema,
} from './schema/ValidationDashboardListSchema';
import { ValidationDashboardUpdateSchema } from './schema/ValidationDashboardUpdateSchema';

export enum DashboardType {
  CROSSTABLE = 'CROSSTABLE',
  TIME_SERIES = 'TIME_SERIES',
  COMPARISON = 'COMPARISON',
  TIME_SERIES_COMPARISON = 'TIME_SERIES_COMPARISON',
  REPORT = 'REPORT',
  HODRICK_PRESCOTT = 'HODRICK_PRESCOTT',
  OUTLIERS = 'OUTLIERS',
  HODRICK_PRESCOTT_COMPARISON = 'HODRICK_PRESCOTT_COMPARISON',
  OUTLIERS_COMPARISON = 'OUTLIERS_COMPARISON',
}

export type ValidationDashboardListDto = z.infer<
  typeof ValidationDashboardSchema
>;
export type ValidationDashboardDataObjectVersionType = z.infer<
  typeof ValidationDashboardDataObjectVersionSchema
>;
export type ValidationDashboardUpdateValidFormType = z.infer<
  typeof ValidationDashboardUpdateSchema
>;
